// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"ActivityLogComponent_tableContainer__ZE0tI","dateValues":"ActivityLogComponent_dateValues__YiVtz","inputLabels":"ActivityLogComponent_inputLabels__3wZK3"};